import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.sass'],
})
export class QrCodeDialogComponent {
  qrCodeUrl: string; // Declara a propriedade qrCodeUrl

  constructor(
    public dialogRef: MatDialogRef<QrCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) 
    public data: { 
      qrCodeUrl: string 
    }
  ) {
    this.qrCodeUrl = data.qrCodeUrl; // Atribui o valor recebido à propriedade
  }

  onClose(): void {
    this.dialogRef.close(); // Método para fechar o diálogo
  }
}
